<app-navigationbar></app-navigationbar>
<router-outlet></router-outlet>
